import React from 'react';
import { PatientSuicidalQuestHistory } from '../types/api';

interface SuicidalHistoryTabProps {
    history: PatientSuicidalQuestHistory[];
    isLoading: boolean;
}

export const SuicidalHistoryTab: React.FC<SuicidalHistoryTabProps> = ({ history, isLoading }) => {
    return (
        <div>
            {/* Header */}
            <div className="bg-white rounded-lg border border-gray-300 overflow-hidden">
                <div className="px-4 py-3 bg-white sticky top-0 z-10 border-b border-gray-300">
                    <h2 className="text-lg font-semibold text-gray-900">Suicidal history</h2>
                </div>

                {/* History List */}
                <div className="max-h-[calc(100vh-250px)] overflow-y-auto">
                    {isLoading ? (
                        <div className="flex items-center justify-center py-12">
                            <div className="text-center">
                                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto"></div>
                                <p className="text-gray-600 mt-4 text-sm">Loading history...</p>
                            </div>
                        </div>
                    ) : history.length === 0 ? (
                        <div className="text-center py-8 text-gray-500">
                            <p className="text-sm">No suicidal questionnaire history available</p>
                        </div>
                    ) : (
                        <div className="px-4 py-3 space-y-3">
                            {history.map((item) => {
                                // Format date from created_at
                                const formattedDate = item.created_at
                                    ? new Date(item.created_at).toLocaleDateString('en-CA', {
                                        year: 'numeric',
                                        month: '2-digit',
                                        day: '2-digit'
                                    }).split('-').join('-') + ' ' +
                                    new Date(item.created_at).toLocaleTimeString('en-US', {
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        hour12: false
                                    })
                                    : '-';

                                return (
                                    <div
                                        key={item.id}
                                        className="bg-[#c8dfe3] rounded-lg px-4 py-3 border-2 border-[#5fa8b5]"
                                    >
                                        {/* Header with date and user */}
                                        <div className="grid grid-cols-2 gap-4 mb-3">
                                            <div className="flex items-center gap-2">
                                                <span className="text-xs font-semibold text-gray-700">On:</span>
                                                <span className="text-xs bg-white/60 px-3 py-1 rounded text-gray-800">{formattedDate}</span>
                                            </div>
                                            <div className="flex items-center gap-2">
                                                <span className="text-xs font-semibold text-gray-700">By:</span>
                                                <span className="text-xs bg-white/60 px-3 py-1 rounded text-gray-800">{item.user_name || '-'}</span>
                                            </div>
                                        </div>

                                        {/* Questions checkboxes */}
                                        <div className="space-y-2">
                                            <label className="flex items-center gap-2 text-sm text-gray-700 cursor-default">
                                                <input
                                                    type="checkbox"
                                                    checked={item.q1}
                                                    readOnly
                                                    className="w-4 h-4 rounded border-gray-400 text-blue-600 focus:ring-0 cursor-default"
                                                />
                                                <span>Death wish in recent weeks</span>
                                            </label>
                                            <label className="flex items-center gap-2 text-sm text-gray-700 cursor-default">
                                                <input
                                                    type="checkbox"
                                                    checked={item.q2}
                                                    readOnly
                                                    className="w-4 h-4 rounded border-gray-400 text-blue-600 focus:ring-0 cursor-default"
                                                />
                                                <span>Thoughts or plans to commit suicide in recent weeks</span>
                                            </label>
                                            <label className="flex items-center gap-2 text-sm text-gray-700 cursor-default">
                                                <input
                                                    type="checkbox"
                                                    checked={item.q3}
                                                    readOnly
                                                    className="w-4 h-4 rounded border-gray-400 text-blue-600 focus:ring-0 cursor-default"
                                                />
                                                <span>In the past, have tried self harm or to commit suicide</span>
                                            </label>
                                            <label className="flex items-center gap-2 text-sm text-gray-700 cursor-default">
                                                <input
                                                    type="checkbox"
                                                    checked={item.q4}
                                                    readOnly
                                                    className="w-4 h-4 rounded border-gray-400 text-blue-600 focus:ring-0 cursor-default"
                                                />
                                                <span>At present, have thoughts of committing suicide</span>
                                            </label>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
